import { render, staticRenderFns } from "./ProgramReport.vue?vue&type=template&id=51205332&scoped=true"
import script from "./ProgramReport.vue?vue&type=script&lang=js"
export * from "./ProgramReport.vue?vue&type=script&lang=js"
import style0 from "./ProgramReport.vue?vue&type=style&index=0&id=51205332&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51205332",
  null
  
)

export default component.exports